import {
  ANALYTICAL_JOURNEY_STAGES,
  getAnalyticalJourneyStage,
} from "./analyticalJourney";

export default function AnalyticalDecisionJourney({ currentStage, currentLabel }) {
  const current = getAnalyticalJourneyStage(currentStage);

  if (!current) {
    throw new Error(`Unknown analytical journey stage: ${currentStage}`);
  }

  const stageNumber = ANALYTICAL_JOURNEY_STAGES.indexOf(current) + 1;

  return (
    <section aria-labelledby="analytical-journey-heading" className="min-w-0">
      <h2
        id="analytical-journey-heading"
        className="text-[11px] font-medium uppercase tracking-[0.2em] text-slate-400"
      >
        Analytical Journey
      </h2>

      <ol className="mt-2 hidden min-w-0 items-center gap-2 text-sm text-slate-500 sm:flex">
        {ANALYTICAL_JOURNEY_STAGES.map((stage, index) => {
          const isCurrent = stage.id === currentStage;

          return (
            <li key={stage.id} className="flex min-w-0 items-center gap-2">
              {index > 0 && (
                <span aria-hidden="true" className="text-slate-300">
                  ›
                </span>
              )}
              <span
                className={
                  isCurrent
                    ? "font-semibold text-amber-700"
                    : "font-medium text-slate-500"
                }
                title={stage.module}
              >
                {isCurrent ? (currentLabel || `${stage.label} — Current`) : stage.label}
              </span>
            </li>
          );
        })}
      </ol>

      <p className="mt-1.5 text-sm font-medium text-slate-600 sm:hidden">
        <span className="text-amber-700">{currentLabel || `${current.label} — Current`}</span>
        <span aria-hidden="true" className="px-1.5 text-slate-300">·</span>
        <span>Stage {stageNumber} of {ANALYTICAL_JOURNEY_STAGES.length}</span>
      </p>
    </section>
  );
}
